import { rpcClient } from "@/api/WebsocketClient"
import { reactive } from '@vue/reactivity'
import ToAddress from '@/model/settings/ToAddress';


export default class GeneratedToAddressStore {

    state: {
        toAddresss: Map<string, ToAddress>,
        calls: Map<string, string | string[]>
    }
    timer: number | null = null

    constructor() {
        let toAddresss: Map<string, ToAddress> | null = null
        try {
            const persistedState = localStorage.getItem('ToAddressStore')
            if (persistedState) {
                toAddresss = new Map(JSON.parse(persistedState))
            }
        } catch (ignore) {}
        this.state = reactive({
            toAddresss: toAddresss || new Map<string, ToAddress>(),
            calls: new Map<string, string | string[]>()
        })
        this.init()
    }

    init() {
        window.setTimeout(() => {
            if (rpcClient) {
                rpcClient.stores.push(this)
            } else {
                this.init()
            }
        }, 1)
    }

    persistState() {
        if (this.timer === null) {
            setTimeout(() => {
                localStorage.setItem('ToAddressStore', JSON.stringify(Array.from(this.state.toAddresss)))
                this.timer = null
            }, 1000)
        }
    }

    clearState() {
        if (this.timer) clearTimeout(this.timer)
        if (this.state?.toAddresss) this.state.toAddresss.clear()
        if (this.state?.calls) this.state.calls.clear()
        localStorage.removeItem('ToAddressStore')
    }

    addOrReplaceToAddress(newToAddress: ToAddress, persist: boolean = true): true | undefined {
        if (newToAddress.id) {
            this.state.toAddresss.set(newToAddress.id, newToAddress)
            
            if (persist) {
                this.persistState()
            } else {
                return true
            }
        }
    }
    
    addOrReplaceToAddresss(newToAddresss: ToAddress[]) {
        let persist = false
        for (const newToAddress of newToAddresss) {
            const changed = !!this.addOrReplaceToAddress(newToAddress, false)
            persist = persist || changed
        }
        if (persist) {
            this.persistState()
        }
    }

    replaceToAddresss(toAddresss: ToAddress[]) {
        const newToAddresss = new Map<string, ToAddress>()
        for (const newToAddress of toAddresss) {
            if (newToAddress.id) {
                newToAddresss.set(newToAddress.id, newToAddress)
                
            }
        }
        this.state.toAddresss = newToAddresss
        this.persistState()
    }

    removeToAddress(id: string | undefined | null, persist: boolean = true): true | undefined {
        if (id !== undefined && id !== null) {
            if (this.state.toAddresss.delete(id)) {
                if (persist) {
                    this.persistState()
                } else {
                    return true
                }
            }
        }
    }

    removeToAddresss(ids: (string | null)[] | undefined | null) {
        let persist = false
        if (ids !== undefined && ids !== null) {
            for (const id of ids) {
                const changed = !!this.removeToAddress(id, false)
                persist = persist || changed
            }
        }
        if (persist) {
            this.persistState()
        }
    }
}